<template>
<div>
  <Banner
    title="aconex"
    pricing="true"
    level="4"
    bg-color="#fff"
    class="sticky-top"
    />
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <Layout10 />
  
  
  
  <b-container style="background-color: #ffb300; font-family: Arial, Helvetica, sans-serif; font-size: 1.2rem;" fluid>
    <b-row class="text-center">
      <b-col cols="12" md="6">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('faster')"
	  >
	  <span class="link-ref-text d-none d-sm-inline">6955% Faster than nearest AI "Competitor"</span>
	  <span class="link-ref-text d-inline d-sm-none">6955% Faster than competitors</span>
	</b-button>
      </b-col>
      <b-col cols="12" md="6">
	<b-button
	  class="border-0 bg-transparent text-dark"
	  style="height: 64px;"
	  @click="goto('get-bundle')"
	  >
	  <span class="link-ref-text">Included with TrinApp Crosslink</span>
	</b-button>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <div ref="faster" />
  <b-container
    class="d-flex section border-top border-muted"
    style="background-color: #08034c;"
    fluid
    >
    <b-row class="m-auto text-center justify-content-center">
      <b-col>
	<b-container
	  class="py-5 px-0 p-sm-5 text-light text-center"
	  fluid
	  >
	  <b-row>
	    <b-col cols="12" lg="6" offset-lg="3">
	      <div class="mx-auto">
		<h2>We are happy to announce that with Oracle aconex Link, you will finish your job about <span class="font-weight-bold" style="text-decoration: underline;">6950% faster</span> than doing it manually"</h2>
	      </div>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <b-container class="py-5" fluid>
    <b-row>
      <b-col class="p-0">
	<ManualVsTrinity />
      </b-col>
    </b-row>
  </b-container>
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <div ref="get-bundle" />
  <GetBundle>
    <div slot="content">
      <b-container>
	<b-row class="m-auto justify-content-center">
	  <b-col
	    cols="3"
	    class="px-0 px-xl-3"
	    >
	    <b-img
	      :src="require('../assets/bundle-aconex.png')"
	      fluid
	      />
	  </b-col>
	  <b-col
	    cols="8"
	    xl="6"
	    class="my-auto text-left"
	    >	      
	    <h1 class="d-inline-block">Crosslink</h1>
	    <h1 class="d-inline-block">+ TrinApp<sup>&trade;</sup> CDE</h1>
	    <h1 class="d-inline-block">+ Oracle aconex Link</h1>
	    <h1 class="d-inline-block">+ TrinPod<sup>&trade;</sup></h1>
	  </b-col>
	</b-row>
      </b-container>
    </div>
  </GetBundle>



  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <GmxFooter />  
</div>
</template>

<script>
import Banner from '@/components/gmx-banner.vue';
import GmxFooter from '@/components/footer.vue';
import Layout10 from '@/components/layout-10.vue';
import ManualVsTrinity from '@/components/manual-vs-trinity.vue';
import GetBundle from '@/components/get-bundle.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
export default {
    name: "ConstructionTrinPodAconex",
    components: {
	Banner,
	GmxFooter,
	Layout10,
	ManualVsTrinity,
	GetBundle,
	FontAwesomeIcon
    },
    data () {
	return {
	    faCheck
	}
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

